import { createFeatureAllowed } from '@apeiron/temp'
import { FEATURE_FLAG_MAP } from '@src/constants/featureFlag'

/** @deprecated - use to hide feature, but avoid using in long term */
export default createFeatureAllowed(FEATURE_FLAG_MAP)
